// src/pages/AdminPage.tsx
import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext, User } from '../context/AuthContext';
import '../App.css';

function AdminPage() {
    // ВСЕ ВЫЗОВЫ ХУКОВ ДОЛЖНЫ БЫТЬ ВЫШЕ ЛЮБОЙ УСЛОВНОЙ ЛОГИКИ ИЛИ РАННЕГО ВОЗВРАТА!
    const auth = useContext(AuthContext); // Вызов хука в начале
    const navigate = useNavigate();       // Вызов хука в начале

    const [newUsername, setNewUsername] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [newUserRole, setNewUserRole] = useState<'user' | 'admin'>('user');
    const [adminMessage, setAdminMessage] = useState('');
    const [viewingUserLists, setViewingUserLists] = useState<string | null>(null);
    const [selectedUserLists, setSelectedUserLists] = useState<any[]>([]);

    // Проверяем, что у нас есть авторизованный админ
    useEffect(() => {
        if (!auth || !auth.user || auth.user.role !== 'admin') {
            navigate('/login');
        }
    }, [auth, navigate]);

    if (!auth || !auth.user || auth.user.role !== 'admin') {
        return null;
    }

    const {
        logout,
        user,
        allUsers,
        registerUser,
        updateUserStatus,
        deleteUser,
        getUserBasicLists,
    } = auth;

    const showAdminSnackbar = (msg: string) => {
        setAdminMessage(msg);
        setTimeout(() => setAdminMessage(''), 3000);
    };

    const handleRegisterNewUser = (e: React.FormEvent) => {
        e.preventDefault();
        if (!newUsername.trim() || !newPassword.trim()) {
            showAdminSnackbar('Имя пользователя и пароль не могут быть пустыми.');
            return;
        }
        const result = registerUser(newUsername.trim(), newUserRole);
        if (result.success) {
            showAdminSnackbar(result.message);
            setNewUsername('');
            setNewPassword('');
            setNewUserRole('user');
        } else {
            showAdminSnackbar(result.message);
        }
    };

    const handleToggleBlockUser = (targetUsername: string, isBlocked: boolean) => {
        if (targetUsername === user.username) {
            showAdminSnackbar('Нельзя заблокировать самого себя.');
            return;
        }
        updateUserStatus(targetUsername, isBlocked);
        showAdminSnackbar(`Пользователь "${targetUsername}" ${isBlocked ? 'заблокирован' : 'разблокирован'}.`);
    };

    const handleDeleteUser = (targetUsername: string) => {
        if (targetUsername === user.username) {
            showAdminSnackbar('Нельзя удалить самого себя.');
            return;
        }
        if (window.confirm(`Вы уверены, что хотите удалить пользователя "${targetUsername}"? Это действие необратимо.`)) {
            deleteUser(targetUsername);
            showAdminSnackbar(`Пользователь "${targetUsername}" удален.`);
        }
    };

    const handleViewUserLists = (targetUsername: string) => {
        setViewingUserLists(targetUsername);
        const lists = getUserBasicLists(targetUsername);
        setSelectedUserLists(lists);
    };

    const handleCloseUserListsModal = () => {
        setViewingUserLists(null);
        setSelectedUserLists([]);
    };

    return (
        <div className="container">
            <div className="dashboard-header-controls">
                <button className="btn-small" onClick={logout}>Выйти ({user.username})</button>
                <button className="btn-small" onClick={() => navigate('/dashboard')}>
                    <span className="icon">
                        <svg viewBox="0 0 24 24">
                            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
                        </svg>
                    </span>
                    Dashboard
                </button>
            </div>

            <div className="admin-page">
                <h2>Панель администратора</h2>
                <p>Добро пожаловать, {user.username} (роль: {user.role})!</p>

                {adminMessage && <div id="snackbar" className="show">{adminMessage}</div>}

                {/* Секция добавления нового пользователя */}
                <div className="admin-section">
                    <h3>Добавить нового пользователя</h3>
                    <form onSubmit={handleRegisterNewUser} className="add-user-form">
                        <div className="input-group">
                            <label htmlFor="newUsername">Имя пользователя:</label>
                            <input
                                type="text"
                                id="newUsername"
                                value={newUsername}
                                onChange={(e) => setNewUsername(e.target.value)}
                                required
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="newPassword">Пароль (для имитации):</label>
                            <input
                                type="password"
                                id="newPassword"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="newUserRole">Роль:</label>
                            <select
                                id="newUserRole"
                                value={newUserRole}
                                onChange={(e) => setNewUserRole(e.target.value as 'user' | 'admin')}
                            >
                                <option value="user">Пользователь</option>
                                <option value="admin">Администратор</option>
                            </select>
                        </div>
                        <button type="submit" className="btn">Зарегистрировать пользователя</button>
                    </form>
                </div>

                {/* Секция списка пользователей */}
                <div className="admin-section">
                    <h3>Управление пользователями</h3>
                    {allUsers.length === 0 ? (
                        <p>Пользователи не найдены.</p>
                    ) : (
                        <table className="users-table">
                            <thead>
                                <tr>
                                    <th>Имя пользователя</th>
                                    <th>Роль</th>
                                    <th>Статус</th>
                                    <th>Действия</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allUsers.map((u: User) => (
                                    <tr key={u.username} className={u.isBlocked ? 'blocked-user' : ''}>
                                        <td>{u.username}</td>
                                        <td>{u.role}</td>
                                        <td>{u.isBlocked ? 'Заблокирован' : 'Активен'}</td>
                                        <td className="user-actions">
                                            {u.username !== user.username && (
                                                <>
                                                    <button
                                                        className={`btn-small ${u.isBlocked ? 'btn-unblock' : 'btn-block'}`}
                                                        onClick={() => handleToggleBlockUser(u.username, !u.isBlocked)}
                                                    >
                                                        {u.isBlocked ? 'Разблокировать' : 'Заблокировать'}
                                                    </button>
                                                    <button
                                                        className="btn-small btn-delete"
                                                        onClick={() => handleDeleteUser(u.username)}
                                                    >
                                                        Удалить
                                                    </button>
                                                </>
                                            )}
                                            <button
                                                className="btn-small btn-view-lists"
                                                onClick={() => handleViewUserLists(u.username)}
                                            >
                                                Списки
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>

                {/* Модальное окно для просмотра списков пользователя */}
                {viewingUserLists && (
                    <div className="modal-overlay">
                        <div className="modal">
                            <h3>Списки ключевых слов пользователя: “{viewingUserLists}”</h3>
                            {selectedUserLists.length > 0 ? (
                                <div className="scrollable-content">
                                    {selectedUserLists.map((list: any) => (
                                        <div key={list.name} className="user-list-item">
                                            <h4>{list.name} ({list.keywords.length} слов)</h4>
                                            <textarea
                                                value={list.keywords.join('\n')}
                                                readOnly
                                                rows={Math.min(5, list.keywords.length + 1)}
                                                className="user-list-textarea"
                                            />
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p>У пользователя “{viewingUserLists}” нет сохранённых списков.</p>
                            )}
                            <div className="modal-buttons">
                                <button onClick={handleCloseUserListsModal}>Закрыть</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default AdminPage;
